<template functional>
    <div class="loader" data-flex="root center">
        <div class="loader__logo">
            <img src="@/assets/img/logo-sign2.png" alt="loading">
            <strong>Loading...</strong>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loader',
    data() {
        return {
            loading: true
        }
    },
    // created() {
    //     window.addEventListener('load', () => {
    //         this.loading = false;
    //         setTimeout(() => {
    //             this.$emit('loaded', !this.loading)
    //         }, 2000);

    //     })
    // }
}
</script>

<style lang="scss" scoped>
    @keyframes loading {
        to {
            transform: rotate(360deg)
        }
    }
    .loader {
        position: fixed;
        top: 0;
        left: 0;
        min-width: 100%;
        justify-content: center;
        text-align: center;
        flex-wrap: nowrap;
        z-index: 4;
        background: #fff;
        &__logo {
            strong {
                display: block;
                padding-top: 20px;
                color: #777
            }
            img {
                animation: loading 1s infinite forwards
            }
        }
    }
</style>
